import Text from './text';
import H1 from './h1';
import H2 from './h2';
import H3 from './h3';
import H4 from './h4';
import H5 from './h5';
import H6 from './h6';
import BodyExtraSmall from './body-extra-small';
import BodySmall from './body-small';
import BodyBase from './body-base';
import BodyLarge from './body-large';
Text.H1 = H1;
Text.H2 = H2;
Text.H3 = H3;
Text.H4 = H4;
Text.H5 = H5;
Text.H6 = H6;
Text.BodyExtraSmall = BodyExtraSmall;
Text.BodySmall = BodySmall;
Text.BodyBase = BodyBase;
Text.BodyLarge = BodyLarge;
export default Text;
//# sourceMappingURL=index.js.map